function makeFaqAnswerHtml(text) {
  return "<p>" + text.replace(/\n/g, "</p><p class='mt-2'>") + "</p>";
}
export { makeFaqAnswerHtml };
